<div class="hardware-shop-page">
    <div class="hardware-shop-header">
        <h1>Hardware &amp; Accessories</h1>
        <p>Browse the terminals, readers and accessories LincSell supports. Add what you need and check out.</p>
    </div>

    <div class="hardware-owned-card" *ngIf="purchasedHardwareList.length">
        <div class="hardware-owned-card-header">
            <h3>Your hardware</h3>
            <div class="hardware-owned-summary">{{ purchasedHardwareTotalQty }} devices &middot; {{ purchasedHardwareTotalPrice | currency | currencySpacing }} purchased</div>
        </div>
        <div class="hardware-owned-list">
            <div class="hardware-owned-row" *ngFor="let hw of purchasedHardwareList; trackBy: trackHardwareByName">
                <img [src]="hw.image" alt="" class="hardware-owned-img" onerror="this.style.visibility='hidden'" />
                <div class="hardware-owned-main">
                    <div class="hardware-owned-name">{{ hw.name }}</div>
                    <div class="hardware-owned-date">Purchased {{ hw.purchasedDate | date : "MMM d, yyyy" }}</div>
                </div>
                <div class="hardware-owned-qty-pill">Qty {{ hw.qty }}</div>
            </div>
        </div>
    </div>

    <div class="hardware-shop-section-label">{{ purchasedHardwareList.length ? "Buy More Hardware" : "Shop Hardware" }}</div>

    <ng-container *ngIf="!isLoading; else hardwareShopLoading">
        <div class="hardware-shop-category" *ngFor="let category of hardwareCategories">
            <h2 class="hardware-shop-category-title">{{ category.title }}</h2>
            <div class="hardware-shop-grid">
                <div class="hardware-shop-card" *ngFor="let item of category.items" [class.in-cart]="item.quantity > 0">
                    <div class="hardware-shop-card-head">
                        <button type="button" class="hardware-info-btn" (click)="openInfo(item)"><i class="pi pi-info"></i></button>
                        <div class="hardware-shop-card-title">{{ item.title }}</div>
                        <div class="hardware-shop-card-subtitle">{{ getHardwareInfo(item).subtitle }}</div>
                        <span class="hardware-shop-card-badge" *ngIf="item.quantity > 0">In your order &middot; {{ item.quantity }}</span>
                    </div>
                    <img [src]="item.image" alt="" class="hardware-shop-card-img" onerror="this.style.visibility='hidden'" />
                    <div class="hardware-shop-card-footer">
                        <div class="hardware-shop-card-price">{{ item.price | currency | currencySpacing }}</div>
                        <div class="hardware-shop-card-stepper">
                            <button pButton type="button" icon="pi pi-minus" class="p-button-text p-button-sm" [disabled]="!item.quantity" (click)="decrement(item)"></button>
                            <span>{{ item.quantity }}</span>
                            <button pButton type="button" icon="pi pi-plus" class="p-button-text p-button-sm" (click)="increment(item)"></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
    <ng-template #hardwareShopLoading>
        <div class="hardware-shop-grid">
            <p-skeleton *ngFor="let row of [1,2,3,4,5,6]" width="100%" height="15rem"></p-skeleton>
        </div>
    </ng-template>

    <div class="hardware-shop-footer" *ngIf="!isLoading">
        <div class="hardware-shop-footer-summary">
            <span class="count">{{ selectedCount }}</span> item(s) selected &middot;
            <span class="total">{{ selectedTotal | currency | currencySpacing }}</span>
        </div>
        <button pButton type="button" label="Proceed to checkout" [disabled]="!canProceed" [title]="!USAGE_HARDWARE_PURCHASE_ENABLED ? 'Hardware ordering is temporarily unavailable — contact support to order hardware for your account.' : ''" (click)="proceedToCheckout()"></button>
    </div>
    <p class="hardware-shop-unavailable-note" *ngIf="!USAGE_HARDWARE_PURCHASE_ENABLED && !isLoading">
        Hardware ordering is temporarily unavailable. Please contact support if you'd like to order hardware for your account.
    </p>

    <p-dialog [(visible)]="infoDialogVisible" [modal]="true" [draggable]="false" [resizable]="false" [showHeader]="false" [style]="{ width: '480px', maxWidth: '92vw' }" styleClass="hardware-info-dialog">
        <ng-container *ngIf="infoItem">
            <div class="hardware-info-header">
                <div>
                    <div class="hardware-info-title">{{ infoItem.title }}</div>
                    <div class="hardware-info-subtitle">{{ getHardwareInfo(infoItem).subtitle }}</div>
                </div>
                <button type="button" class="hardware-info-close" (click)="closeInfo()"><i class="pi pi-times"></i></button>
            </div>
            <img [src]="infoItem.image" alt="" class="hardware-info-img" onerror="this.style.visibility='hidden'" />
            <p class="hardware-info-description">{{ getHardwareInfo(infoItem).description }}</p>
            <ul class="hardware-info-features" *ngIf="getHardwareInfo(infoItem).features.length">
                <li *ngFor="let feature of getHardwareInfo(infoItem).features"><i class="pi pi-check"></i> {{ feature }}</li>
            </ul>
            <div class="hardware-info-footer">
                <div class="hardware-info-price">{{ infoItem.price | currency | currencySpacing }}</div>
                <button pButton type="button" label="Add to order" class="hardware-info-add-btn" (click)="addToOrderFromInfo()"></button>
            </div>
        </ng-container>
    </p-dialog>
</div>
